import React, { useState, useRef } from 'react';
import { View } from '@uncinc/react-drupal-core';
import {
  Container,
  WysiwygField,
  useWindowDimensions,
} from '@uncinc/uncinc-react-kitchen-sink';
import { List } from 'immutable';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';

import {
  SCREEN_TABLET,
  SCREEN_NORMAL,
  NAVIGATION_BAR_HEIGHT_MOBILE,
  NAVIGATION_BAR_HEIGHT_TABLET,
  NAVIGATION_BAR_HEIGHT_NORMAL,
} from '../../../config/constants';

import './style.scss';
import LocationMarkers from '../../View/LocationMarkers';
import LocationsSlider from '../../View/LocationSlider';
import LocationsMap from '../../../components/LocationsMap';

const ParagraphLocationsMap = ({ entity }) => {
  const mapRef = useRef(null);
  const markerRef = useRef([]);
  const [filterArray, setFilterArray] = useState([]);
  const { width } = useWindowDimensions();
  const { t } = useTranslation();

  const title = entity.getIn(['field_title', 0, 'value'], '');
  const text = entity.getIn(['field_text', 0, 'processed']);
  const entities = useSelector((state) => state.getIn(['view', 'locations', 'block_1', 'entities'], List()));

  const onClickShowMarker = (uuid, coordinates) => {
    const map = mapRef.current;
    if (!map) {
      return;
    }
    const mapContainer = map.getContainer();
    const rect = mapContainer.getBoundingClientRect();

    map.flyTo(coordinates);
    markerRef.current[uuid].openPopup();
    // Scroll to map if map is not in viewport; for showing the popup.
    if (rect.top < 0) {
      // Use different scroll offsets for different navigation bar sizes.
      let offset = NAVIGATION_BAR_HEIGHT_NORMAL;
      if (width < SCREEN_TABLET) {
        offset = NAVIGATION_BAR_HEIGHT_MOBILE;
      }
      else if (width < SCREEN_NORMAL) {
        offset = NAVIGATION_BAR_HEIGHT_TABLET;
      }

      const targetScrollY = window.scrollY + rect.top - offset;
      window.scrollTo({ top: targetScrollY, behavior: 'smooth' });
    }
  };

  // Disable tabbable markers for A11y, only the locations slider remains tabbable.
  setTimeout(() => {
    const markers = document.querySelectorAll('.leaflet-marker-icon');
    markers.forEach((el) => el.setAttribute('tabindex', '-1'));
  }, 1000);

  let entitiesFiltered = entities;
  if (filterArray.length) {
    entitiesFiltered = entities.filter((entity) => filterArray.includes(entity.getIn(['field_location_type', 0, 'entity', 'tid', 0, 'value'])));
  }

  if (!entities.size) {
    return (
      <View
        id="locations"
        display="block_1"
        block=""
      />
    );
  }

  return (
    <div className="ParagraphLocationsMap">
      <Container>
        <div className="row">
          <div className="col-12 col-md-10 offset-md-1 col-lg-8 offset-lg-2">
            <div className="ParagraphLocationsMap__title">
              {title && (<h2 className="asH1">{title}</h2>)}
            </div>
            {text
              && (
                <div className="ParagraphLocationsMap__text">

                  <WysiwygField
                    property="schema:text"
                    html={text}
                  />

                </div>
              )}
          </div>
        </div>

        <div className="MultipleFieldsFilter">
          <p onClick={() => setFilterArray([])}>{t('components.search.facets.combined_types.title')}</p>
          <View
            id="location_types"
            display="block_1"
            filterArray={filterArray}
            setFilterArray={setFilterArray}
          />
        </div>
      </Container>

      <LocationsMap mapRef={mapRef}>
        <LocationMarkers
          markerRef={markerRef}
          entities={entitiesFiltered}
        />
      </LocationsMap>

      <LocationsSlider
        mapRef={mapRef}
        entities={entitiesFiltered}
        onClickShowMarker={onClickShowMarker}
      />
    </div>
  );
};

export default ParagraphLocationsMap;
